import Component from '@glimmer/component';
import { PrismIconBrand } from '@mylighthouse/prism-ember';
import type { IconBrandName } from '@mylighthouse/prism-ember/types/components/prism/icon-brand';
import { t } from 'ember-intl';
import GeneralChartsOtaChart from 'lumen/components/general/charts/ota-chart';

import styles from './channel-discounts.module.css';

interface HotelChannelPricingChartsChannelDiscountsSignature {
  Args: {
    otasWithDiscount: IconBrandName[];
    otasWithMatchingOrHigherPrice: IconBrandName[];
  };
}

export default class HotelChannelPricingChartsChannelDiscounts extends Component<HotelChannelPricingChartsChannelDiscountsSignature> {
  get amountOfDiscounts(): number {
    return this.args.otasWithDiscount.length;
  }

  get chartData(): { y: number }[] {
    return [
      {
        y: this.amountOfDiscounts,
      },
      {
        y: this.totalAmountOfChannels - this.amountOfDiscounts,
      },
    ];
  }

  get chartOptions(): Highcharts.Options {
    return {
      chart: {
        type: 'pie',
        height: 160,
      },
      subtitle: {
        text: `<div class="flex items-baseline text-neutral-default">
                <h1>${this.amountOfDiscounts}</h1>
                <p>/${this.totalAmountOfChannels}</p>
              </div>`,
        useHTML: true,
        align: 'center',
        verticalAlign: 'middle',
      },
      plotOptions: {
        pie: {
          innerSize: '70%',
          dataLabels: {
            enabled: false,
          },
          colors: [
            'var(--prism-color-general-info-500)',
            'var(--prism-color-general-neutral-600)',
          ],
        },
      },
      series: [
        {
          type: 'pie',
          data: this.chartData,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      ],
      tooltip: {
        enabled: false,
      },
    };
  }

  get totalAmountOfChannels(): number {
    return (
      this.args.otasWithDiscount.length +
      this.args.otasWithMatchingOrHigherPrice.length
    );
  }

  <template>
    <GeneralChartsOtaChart
      @chartOptions={{this.chartOptions}}
      @model={{this.chartData}}
    />
    <div class="{{styles.legend}} flex w-full flex-col gap-400">
      <div class="flex justify-between">
        <div class="text-300--regular space-between flex items-center gap-200">
          <div class="bg-general-info-500 rounded-pill h-200 w-200" />
          {{t "general.discount.plural" count=this.amountOfDiscounts}}
        </div>
        <div class="flex">
          {{#each @otasWithDiscount as |ota|}}
            <PrismIconBrand @name={{ota}} />
          {{/each}}
        </div>
      </div>

      <div class="flex justify-between">
        <div class="text-300--regular space-between flex items-center gap-200">
          <div class="bg-general-neutral-200 rounded-pill h-200 w-200" />
          {{t "channel_pricing.compare_channel_prices.matching_or_higher"}}
        </div>
        <div class="flex">
          {{#each @otasWithMatchingOrHigherPrice as |ota|}}
            <PrismIconBrand @name={{ota}} />
          {{/each}}
        </div>
      </div>
    </div>
  </template>
}
